import { Box } from '@web/components/atoms/Layout'
import { Body2, Span } from '@web/components/atoms/Typography'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { useVirtualGiftSection } from '@web/components/page-components/VirtualGiftSection/VirtualGiftSectionProvider'
import { useBrandingsStore } from '@web/components/utils/branding/useBrandingsStore'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { pluralize } from './utils'

let isBannerMounted = false

const VirtualGiftMatchedGivingBanner = () => {
  const [mount, setMount] = useState<HTMLElement | null>(null)
  const [shouldRender, setShouldRender] = useState(false)

  const activeRound = usePageStore(
    (state) => state.activeMatchedGiving?.rounds[state.activeMatchedGiving?.activeRound || 0],
  )
  const primaryColorFromBranding = useBrandingsStore(({ colorData }) => colorData['Brand'])
  const context = useVirtualGiftSection()
  const styles = context.settings.styles.paymentForm?.styles
  const accentColor = useColorWithOpacity(
    styles?.matchedGivingAccentColor,
    styles?.matchedGivingAccentColorOpacity,
    styles?.accentColor ?? primaryColorFromBranding,
  )

  useEffect(() => {
    if (isBannerMounted) {
      return
    }

    const headerSlot = document.getElementById('ge-header-slot')
    if (headerSlot) {
      isBannerMounted = true
      setMount(headerSlot)
      setShouldRender(true)
    }

    return () => {
      isBannerMounted = false
    }
  }, [])

  if (!activeRound || !mount || !shouldRender) return null

  const amount = context.quantity * activeRound.multiplier

  return createPortal(
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      id="ge-virtual-gift-matched-giving-banner"
      w="100%"
      textAlign="center"
      color="#FFF"
      bgColor={accentColor}
      h="48px"
    >
      {context.step === 0 && (
        <Body2 fontSize="lg">
          <Span as="em" textDecor="underline" fontWeight={800}>
            LIMITED OFFER
          </Span>
          : Double your impact
        </Body2>
      )}
      {context.step >= 1 && (
        <Body2 fontSize="lg">
          <Span as="em" textDecor="underline" fontWeight={800}>
            LIMITED OFFER
          </Span>
          : Buy {context.quantity}, fill {amount} {pluralize(context.settings?.styles?.options?.name || 'gift', amount)}
        </Body2>
      )}
    </Box>,
    mount,
  )
}

export default VirtualGiftMatchedGivingBanner
